import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URLS, PLATFORM_TYPE } from "../constants/constants";
import { parseJwt } from "../components/utilities/utils";



export const preCoutingServicesApi = createApi({
  reducerPath: "preCoutingServicesApi",
  tagTypes:['PreCounting','Request'],
  keepUnusedDataFor:0.001,
  baseQuery: fetchBaseQuery({ baseUrl:BASE_URLS.PRECOUNTING_BASE_URL,
    prepareHeaders: (headers) => {
     
      headers.set("atkn_bnd", localStorage?.atkn_bnd);
      headers.set("rtkn_bnd", localStorage?.rtkn_bnd);
      headers.set("channelidobo", "ETPBMS");
      headers.set("PLATFORM-TYPE", PLATFORM_TYPE);
      return headers;
    }, 
  }),
  endpoints: (builder) => ({
    AddElectorMannualy13A: builder.mutation({
      query: (data) => ({
        headers: {
          authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "application/json",
          currentRole: localStorage.userrole,
          //'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
          constType: parseJwt(localStorage.access_token)?.constituencyType,
          constNo:  parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
          
        },
        url: `/api/v1/pre-counting/save13aManuallyCab`,
        method: "POST",
        body: data,
      }),
    }),
    //form13c
    getElector: builder.query({
      query: (electorName) => ({
        headers: {
          authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "application/json",
          currentRole: localStorage.userrole,
          //'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
          constType: parseJwt(localStorage.access_token)?.constituencyType,
          constNo:  parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
        url: `/api/v1/pre-counting/getElectorByNameCab/${electorName}`,
        method: "GET",
      }),
    }),
    getForm13a: builder.query({
      query: () => ({
        headers: {
          authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "application/json",
          currentRole: localStorage.userrole,
          //'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
          constType: parseJwt(localStorage.access_token)?.constituencyType,
          constNo:  parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
        url: `/api/v1/pre-counting/get13aScannedDataCab`,
        method: "GET",
      }),
      providesTags:['PreCounting','Request']
    }),
    Invalid13A: builder.mutation({      
      query: (data) => ({
        headers: {
          authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "application/json",
          currentRole: localStorage.userrole,
          //'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
          constType: localStorage?.access_token && parseJwt(localStorage?.access_token)?.constituencyType,
          constNo:  localStorage?.access_token && parseJwt(localStorage?.access_token)?.authorizedPcs?.[0]
      },
        url: `/api/v1/pre-counting/saveReasonForInvalidationFormACab`,
        method: "POST",
        body: data,
      }),
    }),
    AddElectorMannualy13B: builder.mutation({
     
      query: (data) => ({
        headers: {
          authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "application/json",
          currentRole: localStorage.userrole,
          //'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
          constType: localStorage?.access_token && parseJwt(localStorage.access_token)?.constituencyType,
          constNo:  localStorage?.access_token && parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        }, 
        url: `/api/v1/pre-counting/save13bManuallyCab`,
        method: "POST",
        body: data,
      }),
    }),
    getForm13B: builder.query({
      query: () => ({
          headers: {
            authorization: `Bearer ${localStorage.access_token}`,
            "Content-Type": "application/json",
            currentRole: localStorage.userrole,
            //'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
            constType: localStorage?.access_token && parseJwt(localStorage.access_token)?.constituencyType,
            constNo:  localStorage?.access_token && parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
          },
        url: `/api/v1/pre-counting/get13bScannedDataCab`,
        method: "GET",
      }),
      providesTags:['PreCounting','Request']
    }),

    AddElectorMannualy13C: builder.mutation({
      query: (data) => ({
        headers: {
          authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "application/json",
          currentRole: localStorage.userrole,
          //'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
          constType: localStorage?.access_token && parseJwt(localStorage.access_token)?.constituencyType,
          constNo:  localStorage?.access_token && parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
        url: `/api/v1/pre-counting/save13cManuallyCab`,
        method: "POST",
        body: data,
      }),
    }),
    getForm13C: builder.query({
      query: () => ({
        headers: {
          authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "application/json",
          currentRole: localStorage.userrole,
          //'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
          constType: localStorage?.access_token &&  parseJwt(localStorage.access_token)?.constituencyType,
          constNo:  localStorage?.access_token && parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
        url: `/api/v1/pre-counting/get13cScannedDataCab`,
        method: "GET",
      }),
      providesTags:['PreCounting','Request']
    }),
    Scanner13C: builder.mutation({
      query: (data) => ({
        headers: {
          authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "application/json",
          currentRole: localStorage.userrole,
          //'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
          constType:localStorage?.access_token && parseJwt(localStorage.access_token)?.constituencyType,
          constNo: localStorage?.access_token && parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
        url: `/api/v1/pre-counting/save13cScanningCab`,
        method: "POST",
        body: data,
      }),
      invalidatesTags:['PreCounting']
    }),
    Scanner13Aleft: builder.mutation({
      query: (data) => ({
        headers: {
          authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "application/json",
          currentRole: localStorage.userrole,
          //'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
          constType: localStorage?.access_token && parseJwt(localStorage.access_token)?.constituencyType,
          constNo:  localStorage?.access_token && parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
        url: `/api/v1/pre-counting/save13aLeftScanningCab`,
        method: "POST",
        body: data,
      }),
      invalidatesTags:['PreCounting']
    }),
    Scanner13Aright: builder.mutation({
      query: (data) => ({
        headers: {
          authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "application/json",
          currentRole: localStorage.userrole,
          //'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
          constType: localStorage?.access_token && parseJwt(localStorage.access_token)?.constituencyType,
          constNo:  localStorage?.access_token && parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
        url: `/api/v1/pre-counting/save13aRightScanningCab`,
        method: "POST",
        body: data,
      }),
      invalidatesTags:['PreCounting']
    }),
    Scanner13B: builder.mutation({
      query: (data) => ({
        headers: {
          authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "application/json",
          currentRole: localStorage.userrole,
          //'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
          constType: localStorage?.access_token && parseJwt(localStorage.access_token)?.constituencyType,
          constNo:  localStorage?.access_token && parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
        url: `/api/v1/pre-counting/save13bScanningCab`,
        method: "POST",
        body: data,
      }),
    }),

    Invalid13B: builder.mutation({
      query: (data) => ({
        headers: {
          authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "application/json",
          currentRole: localStorage.userrole,
          //'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
          constType:localStorage?.access_token && parseJwt(localStorage.access_token)?.constituencyType,
          constNo:  localStorage?.access_token && parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
        url: `/api/v1/pre-counting/saveReasonForInvalidationFormBCab`,
        method: "POST",
        body: data,
      }),
    }),

    ScanBallotPaper: builder.mutation({
      query: (data) => ({
        headers: {
          authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "application/json",
          currentRole: localStorage.userrole,
          //'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
          constType: localStorage?.access_token && parseJwt(localStorage.access_token)?.constituencyType,
          constNo:  localStorage?.access_token && parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
        url: `/api/v1/pre-counting/saveBallotPaperCab`,
        method: "POST",
        body: data,
      }),
    }),

    GetBallotPaperData: builder.query({
      query: () => ({
        headers: {
          authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "application/json",
          currentRole: localStorage.userrole,
          //'state': localStorage?.access_token && parseJwt(localStorage.access_token).authorizedStates?.[0],
          constType: localStorage?.access_token && parseJwt(localStorage.access_token)?.constituencyType,
          constNo:  localStorage?.access_token && parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
        url: `/api/v1/pre-counting/getBallotPaperDataCab`,
        method: "GET",
      }),
    }),
  }),
});
export const {
  useAddElectorMannualy13AMutation,
  useGetElectorQuery,
  useGetForm13aQuery,
  useInvalid13AMutation,
  useAddElectorMannualy13BMutation,
  useGetForm13BQuery,
  useInvalid13BMutation,
  useAddElectorMannualy13CMutation,
  useGetForm13CQuery,
  useScanner13CMutation,
  useScanner13AleftMutation,
  useScanner13ArightMutation,
  useScanner13BMutation,
  useScanBallotPaperMutation,
  useGetBallotPaperDataQuery,
} = preCoutingServicesApi;
